export const environment = {
  production: false,
  name: 'test',
  BASE_PATH: 'https://test.api.syneco.net/green-x-energy-hub',
  AUTH: {
    OIDC_ISSUER: 'https://sso.test.hosting.syneco.net/auth/realms/Syneco-Portal',
    REQUIRE_HTTPS: true
  },
  SKIP_CAPTCHA: false,
  JIRA: {
    BASE_URL: 'https://syneco-sandbox-963.atlassian.net'
  }
};
